const firebaseConfig = {
    apiKey: "AIzaSyB7682RBSfFnJE4iXzXNSdceudL_4xpA5Q",
    authDomain: "mental-health-care-aa6ed.firebaseapp.com",
    projectId: "mental-health-care-aa6ed",
    storageBucket: "mental-health-care-aa6ed.appspot.com",
    messagingSenderId: "569629905780",
    appId: "1:569629905780:web:7c7e55d85b8b5b45e59221"
};

export default firebaseConfig;